import Vue from 'vue';
import { ValidationProvider } from 'vee-validate';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import VueResource from 'vue-resource';
import VueClipboard from 'vue-clipboard2';
import App from './App.vue';
import router from './router';
import store from './store';

import '@trevoreyre/autocomplete-vue/dist/style.css';

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(VueClipboard);
Vue.use(Autocomplete);
Vue.component('ValidationProvider', ValidationProvider);

declare module 'vue/types/vue' {
  interface VueConstructor {
    http: any;
    $http: any;
  }
}
Vue.http.interceptors.push((request: any, next: any)  => {
  next((response: any) => {
    if (response.status === 401 ) {
      window.location.href = `/api/auth/login?last=${window.location.href}`;
    } else if (response.status === 406 ) {
      window.location.href = `/termsAndConditions?last=${window.location.href}`;
    }
  });
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
